<div
  #mealFormModal
  class="modal fade"
  id="mealFormModal"
  tabindex="-1"
  aria-labelledby="mealFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="editing">
          Edición de una comida
        </h1>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="!editing">
          Creación de una comida
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="mealForm" (ngSubmit)="onSubmit()">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': title.invalid && title.touched }"
              placeholder="Título"
              formControlName="title"
            />

            <label for="">Título</label>

            <div *ngIf="title.invalid && title.touched" class="text-danger">
              Ingrese un nombre.
            </div>
          </div>

          <div class="input-group">
            <div class="form-floating mb-3">
              <textarea
                class="form-control"
                type="text"
                [ngClass]="{
                  'is-invalid': description.invalid && description.touched
                }"
                placeholder="Descripción"
                formControlName="description"
                style="height: 250px"
              ></textarea>

              <label for="">Descripción</label>
            </div>
          </div>
          <div
            *ngIf="description.invalid && description.touched"
            class="text-danger"
          >
            Ingresa una descripción.
          </div>

          <button
            [disabled]="mealForm.invalid"
            class="col-12 mt-3 d-grid btn-custom"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span *ngIf="editing">Editar</span>
            <span *ngIf="!editing">Crear</span>
          </button>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
